import Swal from 'sweetalert2'
import { PopUpContainer, PopUpHeader, PopUpTitle, PopUpParagraph, PopUpContent } from './style'
import { renderToString } from 'react-dom/server'
import React from 'react'

export interface QuickConnectModalProps {
  title: string
  message: string | JSX.Element
  startupId: string
  onConfirm?: (data: any) => void
}
export const quickConnectModal = ({ title, message, startupId, onConfirm }: QuickConnectModalProps): void => {
  const content = (
    <PopUpContainer>
      <PopUpHeader>
        <PopUpTitle>{title}</PopUpTitle>
      </PopUpHeader>
      <PopUpContent>
        <PopUpParagraph>{message}</PopUpParagraph>
      </PopUpContent>
    </PopUpContainer>
  )

  Swal.fire({
    showCloseButton: true,
    showConfirmButton: true,
    confirmButtonText: 'Salvar',
    cancelButtonText: 'Cancelar',
    showCancelButton: true,
    reverseButtons: true,
    allowOutsideClick: true,
    customClass: {
      popup: 'quickconnect-modal',
      closeButton: 'quickconnect-modal-close',
      container: 'quickconnect-modal-container',
      actions: 'quickconnect-actions',
      confirmButton: 'quickconnect-confirm',
      cancelButton: 'quickconnect-cancel'
    },
    html: renderToString(content),
    width: '800px',
    padding: 0,
    backdrop: 'rgba(0,0,0,0.4)',
    preConfirm: (): any => {
      const modalElement = document.querySelector('.quickconnect-modal')

      const inputs = modalElement?.querySelectorAll('input[type="text"]') as NodeListOf<HTMLInputElement> | null
      const sourceSelect = modalElement?.querySelector('select') as HTMLSelectElement | null
      const descriptionTextarea = modalElement?.querySelector('textarea') as HTMLTextAreaElement | null

      const startupNameError = modalElement?.querySelector('small[data-error-for="startupName"]') as HTMLElement | null
      const startupEmailError = modalElement?.querySelector('small[data-error-for="startupEmail"]') as HTMLElement | null
      const representantError = modalElement?.querySelector('small[data-error-for="representant"]') as HTMLElement | null
      const contactPhoneError = modalElement?.querySelector('small[data-error-for="contactPhone"]') as HTMLElement | null
      const sourceError = modalElement?.querySelector('small[data-error-for="source"]') as HTMLElement | null
      const responsibleError = modalElement?.querySelector('small[data-error-for="responsible"]') as HTMLElement | null
      const areaInterestError = modalElement?.querySelector('small[data-error-for="areaInterest"]') as HTMLElement | null

      if (startupNameError !== null) startupNameError.textContent = ''
      if (startupEmailError !== null) startupEmailError.textContent = ''
      if (representantError !== null) representantError.textContent = ''
      if (contactPhoneError !== null) contactPhoneError.textContent = ''
      if (sourceError !== null) sourceError.textContent = ''
      if (responsibleError !== null) responsibleError.textContent = ''
      if (areaInterestError !== null) areaInterestError.textContent = ''

      const startupNameVal = inputs?.[0]?.value ?? ''
      const startupEmailVal = inputs?.[1]?.value ?? ''
      const representantVal = inputs?.[2]?.value ?? ''
      const contactPhoneVal = (modalElement?.querySelector('input[type="number"]') as HTMLInputElement)?.value ?? ''
      const sourceVal = sourceSelect?.value ?? ''
      const responsibleVal = inputs?.[3]?.value ?? ''

      let hasError = false

      const addBlurClear = (el: HTMLInputElement | HTMLSelectElement | null, errorEl: HTMLElement | null, isValid: () => boolean): void => {
        if (el === null) return
        if (el.getAttribute('data-has-blur-handler') !== 'true') {
          el.setAttribute('data-has-blur-handler', 'true')
          el.addEventListener('blur', () => {
            if (isValid()) {
              el.style.borderColor = ''
              if (errorEl !== null) errorEl.textContent = ''
            }
          })
        }
      }

      const markError = (el: HTMLInputElement | HTMLSelectElement | null, errorEl: HTMLElement | null): void => {
        if (el !== null) {
          el.style.borderColor = '#dc3545'
        }
        if (errorEl !== null) errorEl.textContent = 'O campo não pode ser vazio'
      }

      if (String(startupNameVal).trim() === '') {
        hasError = true
        markError(inputs?.[0] ?? null, startupNameError)
        addBlurClear(inputs?.[0] ?? null, startupNameError, () => String((inputs?.[0]?.value ?? '')).trim() !== '')
      }
      if (String(startupEmailVal).trim() === '') {
        hasError = true
        markError(inputs?.[1] ?? null, startupEmailError)
        addBlurClear(inputs?.[1] ?? null, startupEmailError, () => String((inputs?.[1]?.value ?? '')).trim() !== '')
      }
      if (String(representantVal).trim() === '') {
        hasError = true
        markError(inputs?.[2] ?? null, representantError)
        addBlurClear(inputs?.[2] ?? null, representantError, () => String((inputs?.[2]?.value ?? '')).trim() !== '')
      }
      if (String(contactPhoneVal).trim() === '') {
        hasError = true
        const phoneInput = modalElement?.querySelector('input[type="number"]') as HTMLInputElement | null
        markError(phoneInput, contactPhoneError)
        addBlurClear(phoneInput, contactPhoneError, () => String((phoneInput?.value ?? '')).trim() !== '')
      }
      if (sourceVal === '') {
        hasError = true
        markError(sourceSelect, sourceError)
        addBlurClear(sourceSelect, sourceError, () => (sourceSelect?.value ?? '') !== '')
      }
      if (String(responsibleVal).trim() === '') {
        hasError = true
        markError(inputs?.[3] ?? null, responsibleError)
        addBlurClear(inputs?.[3] ?? null, responsibleError, () => String((inputs?.[3]?.value ?? '')).trim() !== '')
      }
      const areaInterestVal = inputs?.[4]?.value ?? ''
      if (String(areaInterestVal).trim() === '') {
        hasError = true
        markError(inputs?.[4] ?? null, areaInterestError)
        addBlurClear(inputs?.[4] ?? null, areaInterestError, () => String((inputs?.[4]?.value ?? '')).trim() !== '')
      }

      if (hasError) return false

      return {
        startupId: startupId,
        startupName: inputs?.[0]?.value ?? '',
        startupEmail: inputs?.[1]?.value ?? '',
        representant: inputs?.[2]?.value ?? '',
        contactPhone: contactPhoneVal,
        source: sourceVal,
        responsible: responsibleVal,
        areaInterest: areaInterestVal,
        description: descriptionTextarea?.value ?? ''
      }
    }
  }).then((result) => {
    if (result?.isConfirmed && onConfirm !== undefined) {
      onConfirm(result.value)
    }
  })
}
